import axios, { AxiosError } from "axios"
import { APIGenerator } from "../../../utils/genericAPI/GenerateAPI"
import { Wallet, WalletPatch } from "../types/wallet.types"
import { CallbackFunction } from "../../../common/types/callback.types"
import { PayGoCreditDecrypted } from "../../paygo/types/paygo.types"

export const BASE_URL_WALLETS =  process.env.REACT_APP_BACKEND_API_URL +'/api/v1/admin/wallets'
export const BASE_URL_TRANSACTION = process.env.REACT_APP_BACKEND_API_URL +'/api/v1/admin/transactions'
export const getAddPayGoCreditURL = (walletId?: string) => `${BASE_URL_WALLETS}/${walletId || "none"}/transactions/paygo`

export const getURLTransaction = (walletId?: string) => `${BASE_URL_WALLETS}/${walletId || "none"}/transactions`

export const appPayGoCreditAPI = async ({walletId, paygoToken, stationSlug, callback}: {walletId: string, paygoToken: string, stationSlug: string, callback?: CallbackFunction<PayGoCreditDecrypted, AxiosError>}) => {
    return  axios.post(
        getAddPayGoCreditURL(walletId),
        {
            paygo_token: paygoToken,
            station_slug: stationSlug
        }).then((response) => {
            callback && callback({result: response.data as PayGoCreditDecrypted});
            return Promise.resolve(response.data as PayGoCreditDecrypted);
        }).catch((error) => {
            callback && callback({error: error as AxiosError});
            return Promise.reject(error);
        }
    );
}

export const walletsAPI = new APIGenerator<Wallet, WalletPatch, WalletPatch>(BASE_URL_WALLETS)